"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_2 = require("react");
var google_map_react_1 = require("google-map-react");
var Pin_1 = require("./pin/Pin");
var dealersMapStyles_1 = require("./dealersMapStyles");
var useCurrentLocationPosition_1 = require("../../../hooks/useCurrentLocationPosition");
var useGeolocationPermissionStatus_1 = require("../../../hooks/useGeolocationPermissionStatus");
var core_1 = require("@material-ui/core");
var lab_1 = require("@material-ui/lab");
var GeolocationPermissionStatus_1 = require("../../../enum/GeolocationPermissionStatus");
var useWidgetContext_1 = require("../../../../../../common/react/useWidgetContext");
var mapsApiKey_1 = require("../../../../../common/constants/mapsApiKey");
var DealersMap = function (_a) {
    var defaultDealer = _a.defaultDealer, dealers = _a.dealers, selectedDealerId = _a.selectedDealerId, selectDealerId = _a.selectDealerId, disableDealerSelection = _a.disableDealerSelection;
    var styles = dealersMapStyles_1.default();
    var hideDefaultCenterMap = core_1.useTheme().checkoutLite.dealer.hideDefaultCenterMap;
    var defaultCenter = { lat: defaultDealer.latitude, lng: defaultDealer.longitude };
    var currentPosition = useCurrentLocationPosition_1.default().currentPosition;
    var permissionStatus = useGeolocationPermissionStatus_1.default().permissionStatus;
    var configuration = useWidgetContext_1.default().configuration;
    var userCoords = currentPosition ? { lat: currentPosition.latitude, lng: currentPosition.longitude } : null;
    var getSelectedDealerCoords = react_1.useMemo(function () {
        var selectedDealer = dealers.find(function (dealer) { return dealer.externalId === selectedDealerId; });
        return selectedDealer ? { lat: selectedDealer.latitude, lng: selectedDealer.longitude } : null;
    }, [dealers, selectedDealerId]);
    var getCenter = react_1.useMemo(function () {
        // hideDefaultCenterMap condition (do not remove)
        // this is a fix specific for iOS Chrome along with the google-map-react library
        if (hideDefaultCenterMap) {
            return getSelectedDealerCoords || userCoords;
        }
        return getSelectedDealerCoords || userCoords || defaultCenter;
    }, [getSelectedDealerCoords, userCoords, defaultCenter]);
    if (!currentPosition && permissionStatus === GeolocationPermissionStatus_1.GeolocationPermissionStatus.GRANTED) {
        return (<core_1.Box display="flex" justifyContent="center">
        <lab_1.Skeleton width={480} height={475}/>
      </core_1.Box>);
    }
    return (<div className={styles.mapContainer} data-test="container:dealerMap">
      <google_map_react_1.default bootstrapURLKeys={{
        key: mapsApiKey_1.newApiKeyMarkets.includes(configuration.dimensions.brand)
            ? process.env.JLR_GOOGLE_MAPS_API_KEY
            : process.env.GOOGLE_MAPS_API_KEY,
    }} center={getCenter} zoom={7}>
        {dealers.map(function (_a, index) {
        var latitude = _a.latitude, longitude = _a.longitude, externalId = _a.externalId, label = _a.label, address = _a.address;
        var _b;
        return (<Pin_1.default key={externalId} lat={latitude} lng={longitude} index={index + 1} tooltipContent={<core_1.Box data-test="dealer:pinTooltip">
                <core_1.Typography variant="subtitle2" data-test="dealer:pinDealerName">
                  {" " + label + " "}
                </core_1.Typography>
                {((_b = address) === null || _b === void 0 ? void 0 : _b.phone) && (<core_1.Typography variant="subtitle2" data-test="dealer:pinDealerPhone">
                    {" " + address.phone + " "}
                  </core_1.Typography>)}
              </core_1.Box>} selected={selectedDealerId === externalId} disabled={disableDealerSelection} onClick={function () { return selectDealerId(externalId); }}/>);
    })}
      </google_map_react_1.default>
    </div>);
};
exports.default = DealersMap;
